import { AgendaTxPatient } from "../interfaces/agenda.interface";

export const AppConstants = {
  //Dashboard task session Constants
  patient: "Patient",
  discipline: "Discipline",
  therapist: "Therapist",
  physician: "Physician",
  facility: "Facility",
  dateRange: "Date Range",
  SOCDate: "SOC Date",
  documentPendingSignatureTitle: "Documents Pending for Signature",
  documentRejectedSignatureTitle: "Documents Rejected for Signature",

  //Date range Names
  pastFourtyEightHours: "Past 48 Hours",
  lastDay: "Last Day",
  lastThreeDays: "Last 3 Days",
  lastWeek: "Last Week",
  lastOneWeek: "Last 1 Week",
  lastFourteenDays: "Last 14 Days",
  lastMonth: "Last Month",

  timedTypeCPTModalTitle: "Billed Timed Minutes",
  serviceTypeCPTModalTitle: "Billed Service Minutes",
  disabled: "Disabled",
  required: "Required",
  enabled: "Enabled",
  inviteSent: "Invite Sent",
  deleted: "Deleted",
  emDash: "—",
  notAvaialble: "N/A",
  defaultDate: "0001-01-01",
  disableDischargeMsg:
    "Please close the open therapy episode to provide Discharge Date.",
  nullValue: null,
  serviceBilledCPTCode: "N",
  dateSeperator: "-",
  rangeSeperator: "-/-",
  emptyString: "",
  NoneAvailable: "None Available",
  sessions: "sessions",
  days: "days",
  defaultDateFormat: "MM-dd-yyyy",
  MMDDYYYY: "MM/dd/yyyy",
  PT : 'PT',
  OT : 'OT',
  ST : 'ST',
  doublehyphen : "--",
  YYMMDDHHMMSS: "yyyy-MM-dd HH:mm:ss",
  DMYYYYhMMSSA: "D/M/YYYY, h:mm:ss a",
  excludeFromAlerts: "Exclude from Alerts",
  customToday: "custom-today",
  select: "Select",
  effectivestartdate: "effectivestartdate",
  effectiveenddate: "effectiveenddate",
  startdate: "startdate",
  enddate: "enddate",
  StringText: "string",
  Z: "Z",
  cannotBeDeleted: "Cannot Be Deleted",
  ok: "OK",
  None: "none",
  name: "name",
  ASC: "ASC",
  DESC: "DESC",
  dob: "dob",
  delete: "Delete",
  cancel: "Cancel",
  enable: "Enable",
  disable: "Disable",
  notAllowed: "Not allowed",
  arrowdown: "keyboard_arrow_down",
  arrowup: "keyboard_arrow_up",
  error: "Error",
  warning: "Warning",
  noAgenda: "No Agenda",
  billed: "Billed",
  agenda: "Agenda",
  notBilled: "Not Billed",
  note: "Note",
  noDataFound: "No results found",
  T: "T",

  // security permissions
  manage: "M",
  none: "N",
  view: "V",
  zeroValue: 0,

  // eSig Status
  pending: "Pending",
  active: "Active",

  //labourhours
  labourHoursTitle: "Total Labor Hours (Salary)",

  //overtime
  overTimeTitle: "Over Time Configurations",
  //productivity
  productivityTitle: "Productivity Benchmark",
  facilityProductivityTitle: "Facility Productivity Benchmark",
  userProductivityTitle: "User Productivity Benchmark",
  corpDefaultOvertimetype: 2,
  corpDefaultOvertimeHRS: 40,
  corpDefaultWeekTimeLine: 1,
  corpDefaultLabourHrPeriod: 2,
  corpDefaultLabourHrValue: 40,
  corpDefaultProductivity: 80,
  defaultSearchLength: 3,
  millisecondsPerSecond: 1000,
  secondsPerMinute: 60,
  minutesPerHour: 60,
  hoursPerDay: 24,
  daysPerWeek: 7,
  millisecondsPerDay: 1000 * 60 * 60 * 24,
  millisecondsPerWeek: 1000 * 60 * 60 * 24 * 7,

  merge: "merge",
  daterangSeperator: "/s*-s*/",

   // User Rate Exception IDs
   UserRateExceptions: {
    DoNotAllowImpersonate: 1,
    ExcludeFromScheduling: 2, 
    ExcludeFromPayroll: 3,
    ExcludeFromProductivity: 4,
    TimeClockIntegrationOverride: 5
  },

  //agenda status options
  AllAgendaItems: "all",
  ALL: "All",
  Active: "Active",
  InActive: "Inactive",
  Unassigned: "Unassigned",
  AgendaRowDisabled: "ag-row-disabled",
  Removeaction: "Remove",
  InActiveAction: "In-Activate",
  ActivateAction: "Activate",
  skipSpinner: "X-Skip-Spinner",
  forceSpinner: 'X-Force-Spinner',
  AllDisciplines: "PT / OT / ST",

  SORT_OPTIONS: {
    LABELS: {
      ASC: "Sort A-Z",
      DESC: "Sort Z-A",
    },
  },

  TX_AGENDA_BY_THERAPIST: "TX Agenda By Therapist",
  SELECT_THERAPIST: "Select Therapist",
  ASSIGN: "Assign",
  SELECT_ALL: "Select All",
  NO_UNASSIGNED_PATIENTS: "No unassigned patients",
  TOTAL_TREATMENT_HOURS: "Total Treatment Hours",
  TOTAL_SCHEDULED_TIME: "Total Scheduled Time",
  TOTAL_LABOR_ALLOWED: "Total Labor Allowed",
  NO_RESULTS_FOUND: "No results found",
  SEARCH_THERAPIST: "Search therapist",
  UNSAVED_CHANGES: "Unsaved Changes",
  SAVE_BEFORE_CLOSING: "You have unsaved changes. Save before closing?",
  SAVE_AND_CLOSE: "Save and Close",
  DISCARD_AND_CLOSE: "Discard and Close",
  DISCARD_CHANGES: "Discard Changes",
  CONTINUE_EDITING: "Continue Editing",
  ASSIGNMENT_MISMATCH: "Assignment Mismatch",
  NO_SELECTION: "No Selection",
  PLEASE_SELECT_PATIENT: "Please select at least one patient to assign",
  ARE_YOU_SURE_DISCARD: "Are you sure you want to discard all changes?",

  TIME_FORMAT_HM: "{0}h {1}m",
  TIME_FORMAT_PADDED_MINUTE: "{0}h {1}m",
  ASSIGNMENT_MISMATCH_TEMPLATE: (therapistName: string, therapistDisciplines: string, incompatibleCount: number, incompatibleList: string, compatibleCount: number) => `
    <div class="text-left">
      <div class="font-bold mb-2">Therapist ${therapistName} is only qualified for: ${therapistDisciplines}</div>
      
      <div class="mb-2">${incompatibleCount} patient(s) cannot be assigned:</div>
      <div class="pl-4 mb-3">${incompatibleList}</div>
      
      <div>${compatibleCount} compatible patient(s) will still be assigned.</div>
    </div>
  `,
  Save: "Save",
  SaveAndExit: "Save and Exit",
  Open: "open",
  sidebar: "sidebar",
  AgendaDate: "Agenda Date",
  UNASSIGNED_PREFIX: "unassigned-",
  THERAPIST_PREFIX: "therapist-",
  NoDataReports: "No data found for the report generation",
  DefaultPrintError: "Print error. Please use the report module to print schedule at this time.",
  NoAgendaForTheDay: "No Agenda is present for the day",
  DISCIPLINE_MISMATCH: {
    TITLE: "Discipline Mismatch",
    MESSAGE_TEMPLATES: {
      ASSIGN_TO_THERAPIST: (therapistName: string, therapistDisciplines: string, incompatibleCount: number, incompatibleList: string, compatibleCount: number) => `
        <div class="text-left">
          <div class="font-bold mb-2">Therapist ${therapistName} is only qualified for: ${therapistDisciplines}</div>
          
          <div class="mb-2">${incompatibleCount} patient(s) cannot be assigned:</div>
          <div class="pl-4 mb-3">${incompatibleList}</div>
          
          ${compatibleCount > 0 ? 
            `<div>${compatibleCount} compatible patient(s) will still be assigned.</div>` : 
            ''}
        </div>
      `,
      CANNOT_MOVE_BETWEEN_DISCIPLINES: (incompatibleCount: number, incompatibleList: string, targetDiscipline: string) => `
        <div class="text-left">
          <div class="mb-2">${incompatibleCount} patient(s) cannot be moved to ${targetDiscipline} section:</div>
          <div class="pl-4 mb-3">${incompatibleList}</div>
          <div>Patients must stay within their discipline's unassigned section.</div>
        </div>
      `,
      PATIENT_LIST: (patients: AgendaTxPatient[]) => `
        <ul class="list-disc pl-4">
          ${patients.map(p => `<li>${p.patientname}</li>`).join('')}
        </ul>
      `
    }
  },
  PATIENT_LIST_HEADER: (discipline: string) => 
  `<p><strong>${discipline} Patients:</strong></p>`,
  TREATMENT_AGENDA_TITLE: "Treatment Agenda",
  DISCIPLINE_LABEL: "Discipline",
  STATUS_LABEL: "Status",
  THERAPISTS_LABEL: "Therapists",
  PRINT: "Print",
  OPTIONS: "Options",
  ADD_PATIENT: "Add Patient",
  CREATE_GROUP: "Create Group",
  SYNC_AGENDA: "Sync Agenda",
  CANCEL: "Cancel",
  CONTINUE: "Continue",
  TX_BY_THERAPIST: "Tx By Therapist",
  Success:"Success",

  UNASSIGNED_ID: "unassigned_id",
  Mode: "Mode",
  ADD_DISCIPLINE: "Add Discipline",
  close: "close",
  disciplineControl:"discipline",
  therapistControl:"therapist",
  modeControl:"mode",
  disciplineIds:"disciplineIds",
  deleteUserErrorMessage: "An error occurred while deleting the user",
  SAVE_NAME: "Save Name",
  EDIT_NAME: "Edit Name",
};

export const entityKeys = {
  patient: "patient",
  therapist: "therapist",
  billing: "billing",
  profile: "profile",
  billingdate: "billingdate",
  disciplineid: "disciplineid",
  user: "user",
  reports: "reports",
};

export const keys = {
  tabKey: "Tab",
};